import { NavLink } from "react-router-dom";
import styles from "../../../assets/styles/interviews.module.scss";
import { staticInterviews } from "./const";

export const StaticInterviewList = () => {
  return (
    <>
      {staticInterviews.map((interview, index) => (
        <div className={styles.interviews_item} key={index}>
          <div className={styles.thumbnail}>
            <img
              src={require(
                `../../../assets/images/interview/${interview.contentId}/thumbnail.png`,
              )}
              alt=""
            />
          </div>
          <div className={styles.item_text}>
            <p className={styles.title}>{interview.title}</p>
            <div className={styles.btn}>
              <NavLink
                className={styles.btn_secondary}
                to={`/interview/${interview.contentId}`}
                target="_blank"
              >
                インタビューを読む
              </NavLink>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
